import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import getUrl from 'libraries/front-end-core/core/url'
import { AOL_CORPORATE } from 'constants/aol/aol'
import { PRECEDENTS_CONTENT, DOCUMENTS_MENU, DOCUMENTS_CONTENT } from 'constants/controllers'
import Loading from 'components/shared/Loading'

export default new Controller({
  name: PRECEDENTS_CONTENT,
  route: '(:aol/)precedents/:view(/:sectionId(/e/:expanded)(/:precedentId))',
  controller (Router, { scrollMain, url, query, params: { aol, view, sectionId = null, precedentId = null, expanded = null } }, render) {
    const pageId = getUrl(PRECEDENTS_CONTENT, { aol, view, sectionId, precedentId })

    const controller = sectionId === null
      ? DOCUMENTS_MENU
      : DOCUMENTS_CONTENT

    // redirecting to documents
    replaceUrl(
      getUrl(controller, { aol: AOL_CORPORATE, sectionId, focusedId: expanded || precedentId })
    )

    render(
      { Main: Loading },
      {
        view,
        sectionId,
        precedentId,
        expandedSection: expanded,
        aol
      },
      {
        searchType: 'precedents',
        className: 'precedents',
        pageId,
        aol
      }
    )

    return pageId
  }
})
